import { FinancialTabPanel } from '../../../components/FinancialTabPanel';
import { PageWrapper } from '../../../components/PageWrapper';

export const AdminChargePage = () => {
  return (
    <PageWrapper>
      <FinancialTabPanel />
    </PageWrapper>
  );
};
